import call from 'utils/Api';

/* Constants */
import { BLUE_VISITOR_UUID } from 'constants/AppConstants';

/* Utils */
import { getSessionStorage } from 'utils/SessionStorage';

type ResponseType = {
  response_code: number;
};

export default (async function GenerateLeadService({
  name,
  phoneNumber,
  email,
  address,
}: {
  name: string;
  phoneNumber?: string;
  email?: string;
  address?: string;
}): Promise<ResponseType> {
  const { data } = await call('salesforce/generate_lead', {
    name,
    email,
    address,
    phone_number: phoneNumber,
    visitor_uuid: getSessionStorage(BLUE_VISITOR_UUID),
  });
  return data;
});
